import { components } from "@certn/api/generated-schemas/applicant-portal";

export type ConsentListItem =
  components["schemas"]["ApplicantAgreementTemplate"];

/** Same SuperDoc gate as scroll-view: master flag plus published esign payload. */
export function isSuperDocConsent(
  consent: Pick<ConsentListItem, "esign" | "external_id">,
  isSuperdocEnabled: boolean
): boolean {
  return Boolean(consent.esign) && (isSuperdocEnabled || !consent.external_id);
}
